import HorizontalSliderView from './HorizontalSliderView';

export default HorizontalSliderView.extend({
  selectors: {
    elements: '.image-preload-icon',
    container: '.slider-content',
    controls: {
      forward: '.icon-arrow-down',
      backward: '.icon-arrow-up'
    }
  },

  getCurrentOffset: function() {
    return this.$container.position().top;
  },

  getElementSize: function() {
    // noinspection JSValidateTypes
    return this.$elements.first().outerHeight(true);
  },

  setContainerSize: function(value) {
    this.$container.height(value);
  },

  positionContainer: function() {
    this.$container.css('top', this.model.get('currentOffset') + 'px');
  },

  setStartTouch: function(event) {
    this.model.set({
      touchStartMainAxis: event.originalEvent.touches[0].pageY,
      touchStartAuxilaryAxis: event.originalEvent.touches[0].pageX,
      touchStartOffset: this.model.get('currentOffset')
    });
  },

  setCurrentTouch: function(event) {
    this.model.set({
      touchCurrentMainAxis: event.originalEvent.touches[0].pageY,
      touchCurrentAuxilaryAxis: event.originalEvent.touches[0].pageX
    });
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/sliders/VerticalSliderView.js
 **/